var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('LoaderWidget',{attrs:{"height":"370px"}}):_c('div',{style:({ height: _vm.height })},[_c('v-chart',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }